import { FilterSelect, SearchInput, SortIcon } from "@marketplace/shared/ui";
import { getRouteApi } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useSortByOptions } from "../../hooks/use-sort-by-options";
import type { SalesListSortValue } from "../../types";

const route = getRouteApi("/users/sales/");

export const SalesListFilters = () => {
  const { q, sort } = route.useSearch();
  const navigate = route.useNavigate();
  const { t } = useTranslation("users");
  const { t: tCommon } = useTranslation("common");
  const [search, setSearch] = useState(q || "");
  const sortByOptions = useSortByOptions();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({
        search: (prev) => ({
          ...prev,
          q: search,
          page: 1
        })
      });
    }, 300);

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleOrderSearchChange = (value: string) => {
    setSearch(value);
  };

  const handleSortByChange = (value: SalesListSortValue) => {
    navigate({
      search: (prev) => ({
        ...prev,
        q: search,
        page: 1,
        sort: value
      })
    });
  };

  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <SearchInput
          className="lg:w-[634px]"
          placeholder={t("salesListPage.searchPlaceholder")}
          onChange={handleOrderSearchChange}
          value={search}
        />
      </div>
      <div className="flex gap-x-[14px]">
        <FilterSelect
          label={tCommon("sortBy")}
          options={sortByOptions}
          value={sort}
          onChange={(v) => handleSortByChange(v as SalesListSortValue)}
          width={179}
          icon={<SortIcon />}
          dropdownPosition="bottom-end"
        />
      </div>
    </div>
  );
};
